module.exports = "fragment MarketingMultiParagraphFragment on MarketingMultiParagraph {\n  __typename\n  id\n  title\n  content\n  createdAt\n  updatedAt\n}\n"